export const textVariableReplacer = (
  text: string,
  options: {
    [key: string]: unknown;
  },
  translation = false
) => {
  let replacedText = text.slice();
  for (const [variable, value] of Object.entries(options)) {
    if (translation) {
      replacedText = replacedText.replaceAll(`{{${variable}}}`, String(value));
    } else {
      replacedText = replacedText.replaceAll(`{${variable}}`, String(value));
    }
  }

  return replacedText;
};

export const generateClassSlug = (name: string): string => {
  let text = name.replace(/[^a-zA-Z0-9]+/g, '-'); // replace non letter or digits by -
  text = text.toLowerCase(); // lowercase
  text = text.replace(/[^-\w]+/g, ''); // remove unwanted characters

  return text.replace(/^-|-$/g, '');
};

export const skipToContent = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
  const elmToFocus = document.querySelector('H1,H2,H3');
  if (elmToFocus) {
    elmToFocus.setAttribute('tabindex', '-1');
    setTimeout(() => {
      (elmToFocus as HTMLElement).focus({ preventScroll: true });
      elmToFocus.removeAttribute('tabindex');
    }, 100);
  }
};

export const disableScroll = (scrollTop = false, fixed = true) => {
  if (scrollTop) {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'auto'
    });
  }
  if (fixed) {
    document.body.style.position = 'fixed';
    document.body.style.top = '0';
  }
  document.body.style.overflow = 'hidden';
  document.body.style.width = '100%';
};

export const enableScroll = (fixed = true) => {
  if (fixed) {
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
  }
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('width');
};

export function nl2br(text: string): string {
  return text.replace(/\n/g, '<br />');
}
